module.exports = "<!-- Page control -->\n<div class=\"container-fixed page-control\" *ngIf=\"linkName\">\n  <div class=\"row align-items-center no-gutters\" (click)=\"goBack()\">\n    <div class=\"col col-auto pr-2\">\n      <i class=\"icon-arrow-left\"></i>\n    </div>\n    <div class=\"col col-auto ml-2\">\n      <a class=\"font-weight-bold\">{{linkName.toString() | truncate : 40}}</a>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/page-control/page-control.component.html
// module id = 1153
// module chunks = 1